var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import InteractiveElement from 'nucleus-core/containers/InteractiveElement';
import Trigger from 'nucleus-core/containers/Trigger';
import Icon from '@cvent/nucleus-icon';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
* Mobile View for the website navigator.
*/
var WebsiteNavigatorMobileView = /** @class */ (function (_super) {
    __extends(WebsiteNavigatorMobileView, _super);
    function WebsiteNavigatorMobileView(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        _this.openPageDataDialog = _this.openPageDataDialog.bind(_this);
        _this.renderTrigger = _this.renderTrigger.bind(_this);
        _this.renderMenuItem = _this.renderMenuItem.bind(_this);
        _this.renderSubMenuOrItem = _this.renderSubMenuOrItem.bind(_this);
        _this.renderNavigation = _this.renderNavigation.bind(_this);
        return _this;
    }
    WebsiteNavigatorMobileView.prototype.onClick = function (id) {
        var _this = this;
        return function () {
            var _a = _this.props, navigateToPage = _a.navigateToPage, closeNavigatorDialog = _a.closeNavigatorDialog;
            navigateToPage(id);
            if (closeNavigatorDialog) {
                closeNavigatorDialog();
            }
        };
    };
    WebsiteNavigatorMobileView.prototype.openPageDataDialog = function () {
        var openNavigatorDialog = this.props.openNavigatorDialog;
        if (openNavigatorDialog) {
            var content = this.renderNavigation();
            var style = __assign(__assign({}, resolve(this.props, 'pageMenu').style), { backgroundColor: this.props.style.verticalMenu.backgroundColor });
            var pageLinks = resolve(this.props, 'pageLinks').style;
            var closeStyle = __assign(__assign({}, pageLinks), { backgroundImage: 'none', backgroundColor: 'none', fontSize: '1.25em', textAlign: 'right' });
            var headerStyle = {
                boxSizing: 'border-box',
                fontSize: '1.75em',
                textAlign: 'right',
                width: '100%',
                padding: '.313em .313em 0'
            };
            openNavigatorDialog(content, {
                dragContainer: style,
                exit: closeStyle,
                header: headerStyle
            });
        }
    }; // Make trigger for dropdown or hamburger menu
    WebsiteNavigatorMobileView.prototype.renderTrigger = function (menu, name, showAsSelectedGroup) {
        var _this = this;
        var _a = this.props, selectedPage = _a.selectedPage, classes = _a.classes, style = _a.style;
        var pageLinkStyles = resolve(this.props, 'pageLinks', showAsSelectedGroup ? 'selected' : '');
        return React.createElement(Trigger, { classes: classes, style: style, allowMouse: false, ref: function (ref) { return _this.trigger = ref; } },
            React.createElement("div", __assign({}, pageLinkStyles),
                React.createElement("span", { className: classes.selectedPage }, name || selectedPage.name),
                React.createElement(Icon, { icon: 'expand', modifier: classes.menuIcon })),
            menu);
    }; // Individual link item
    WebsiteNavigatorMobileView.prototype.renderMenuItem = function (page, menuType) {
        var selectedPage = this.props.selectedPage;
        var pageLinks = resolve(this.props, 'pageLinks', page.id === selectedPage.id ? 'selected' : '');
        pageLinks.style.backgroundImage = 'none';
        return React.createElement("li", __assign({ key: page.id }, resolve(this.props, 'menuItem', menuType)),
            React.createElement(InteractiveElement, __assign({}, pageLinks, { onClick: this.onClick(page.id) }), page.name));
    }; // Created Trigger and Sub Group pages
    WebsiteNavigatorMobileView.prototype.renderSubMenuOrItem = function (item, menuType) {
        var _this = this;
        if (!item.childPages) {
            return this.renderMenuItem(item, menuType);
        }
        if (!item.childPages.length > 0) {
            return null;
        }
        var subMenu = React.createElement("ul", __assign({}, resolve(this.props, 'subMenu', menuType)), item.childPages.map(function (childItem) { return _this.renderSubMenuOrItem(childItem, 'sub'); }));
        var selectedPage = this.props.selectedPage;
        var selectedPageInGroup = item.childPages.map(function (childPage) { return childPage.id; }).includes(selectedPage.id);
        return React.createElement("li", __assign({ key: item.id }, resolve(this.props, 'menuItem', menuType)), this.renderTrigger(subMenu, item.name, selectedPageInGroup));
    }; // Parent Navigation UL - Create sub menu or direct link...
    WebsiteNavigatorMobileView.prototype.renderNavigation = function () {
        var _this = this;
        var pageData = this.props.pageData;
        var textAlign = this.props.style.pageLinks.textAlign;
        return React.createElement("ul", __assign({}, resolve(this.props, textAlign, 'menu', 'verticalMenu')), pageData.map(function (item) { return _this.renderSubMenuOrItem(item, 'vertical'); }));
    };
    WebsiteNavigatorMobileView.prototype.render = function () {
        var _a = this.props, leftContent = _a.leftContent, rightContent = _a.rightContent, classes = _a.classes, translate = _a.translate, hideNavigationMenu = _a.hideNavigationMenu;
        var mobilePageLinks = __assign(__assign({}, resolve(this.props, 'pageLinks').style), { textAlign: 'left', backgroundImage: 'none', borderStyle: 'none' });
        var content = React.createElement("div", __assign({}, resolve(this.props, 'hamburgerWrapper')),
            React.createElement(InteractiveElement, { "aria-label": translate('_buttonText_menu__resx'), style: mobilePageLinks, onClick: this.openPageDataDialog },
                React.createElement(Icon, { icon: 'menuFilled', modifier: classes.menuIcon })));
        return React.createElement("div", __assign({}, resolveTestId(this.props), resolve(this.props, 'container')),
            React.createElement("div", { className: classes.group },
                !hideNavigationMenu && React.createElement("div", __assign({}, resolve(this.props, 'navigation')), content),
                rightContent && React.createElement("div", __assign({}, resolve(this.props, 'rightContent')), rightContent)),
            leftContent && React.createElement("div", __assign({}, resolve(this.props, 'leftContent')), leftContent));
    };
    WebsiteNavigatorMobileView.displayName = 'WebsiteNavigatorMobileView';
    WebsiteNavigatorMobileView.propTypes = {
        selectedPage: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string
        }),
        hideNavigationMenu: PropTypes.bool,
        pageData: PropTypes.array,
        navigateToPage: PropTypes.func,
        openNavigatorDialog: PropTypes.func,
        closeNavigatorDialog: PropTypes.func,
        leftContent: PropTypes.node,
        rightContent: PropTypes.node,
        translate: PropTypes.func
    };
    WebsiteNavigatorMobileView.defaultProps = {
        hideNavigationMenu: false
    };
    return WebsiteNavigatorMobileView;
}(React.Component));
export default WebsiteNavigatorMobileView;
